export default __webpack_public_path__ + "static/media/Send2.14859dd7.svg";